<template>
  <div class="NewMemberUpgrade" v-if="swiperOption">
    <div class="partOne">
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in levelList" :key="index">
          <div class="card" :class="item.levelClass">
            <span class="iconfont icon-jiangpai-shi bgModify"></span>
            <div class="currentLevel" v-if="item.isCurrentLevel">当前等级</div>
            <div class="topPart">
              <van-image round class="header" :src="headPortraitUrl" />
              <span class="iconfont" :class="item.iconfont"></span>
              <div class="levelName" v-text="item.levelName"></div>
            </div>
            <div class="bottomPart">
              <div class="textspeedOfProgress">
                <span v-text="item.taskProgress.taskProgressText"></span>
                <div v-show="item.taskProgress.isShowGoToUpgrade" class="goToUpgrade" @click="goToUpgrade(item.taskProgress.changeCardLevel)">
                  去升级
                </div>
              </div>
              <van-progress v-show="item.taskProgress.isShowProgress" class="speedOfProgress" :percentage="item.taskProgress.percentage" :show-pivot="false" :color="item.taskProgress.progressColor" />
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <!-- swiper end -->
      <div class="vipPrivilege" v-if="currentLevelItem">
        <div class="title">会员特权</div>
        <div class="privilegeCard">
          <div class="leftPart">
            <span class="iconfont icon-vip-card"></span>
            <div class="subCon">
              <div class="subTitle">免单卡奖励</div>
              <div class="subTip oneRow" v-text="currentLevelItem.vipPrivilege.vipPrivilegeText"></div>
            </div>
          </div>
          <div v-if="currentLevelItem.vipPrivilege.vipPrivilegeBtnStatus === 2" class="btnStatus2 textBtn">
            未达到
          </div>
          <div v-if="currentLevelItem.vipPrivilege.vipPrivilegeBtnStatus === 3" class="btnStatus1 normalbtn">
            {{ surplusGetDays }}
          </div>
          <div v-if="currentLevelItem.vipPrivilege.vipPrivilegeBtnStatus === 4" class="btnStatus3 normalbtn activeBtn tapActive" @click="getFreeCard">
            前往领取
          </div>
        </div>
      </div>
      <!-- 会员特权 end -->
    </div>
    <div class="upgradeTask" v-if="currentLevelItem && currentLevelItem.upgradeTask.haveTask">
      <div class="title">
        <span>升级任务</span>
        <div class="stage">
          <span :class="currentLevelItem.upgradeTask.taskProgressIcon.from" class="iconfont"></span>
          <span class="iconfont icon-jiantou_xiangyou_o"></span>
          <span :class="currentLevelItem.upgradeTask.taskProgressIcon.to" class="iconfont"></span>
        </div>
      </div>
      <div class="taskList">
        <div class="taskItem" v-if="currentLevelItem.upgradeTask.inviteFrientTask">
          <div :class="currentLevelItem.levelClass" class="iconBox">
            <span class="iconfont icon-yaoqing2"></span>
          </div>
          <div class="itemRightBox">
            <div class="itemRightPart">
              <div class="subLeftPart">
                <div class="taskNameBox">
                  <span class="taskName">邀请好友</span
                  ><van-tag v-if="currentLevelItem.upgradeTask.needFriendCount" type="primary" color="#feeeee" round text-color="#f26161"
                    >还差{{ currentLevelItem.upgradeTask.needFriendCount }}位</van-tag
                  >
                  <span v-if="!currentLevelItem.upgradeTask.needFriendCount" class="iconfont icon-icon-test"></span>
                </div>
                <div class="tip" v-text="currentLevelItem.upgradeTask.inviteFrientTask.taskCon"></div>
              </div>
              <div v-if="!currentLevelItem.upgradeTask.isAchieveCurrentLevel" class="doTask normalbtn greyBtn">请先升级至{{ currentLevelItem.upgradeTask.VLevel }}</div>
              <div v-else-if="currentLevelItem.upgradeTask.needFriendCount" class="doTask normalbtn activeBtn" @click="invitationNow()">
                去邀请
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentLevelItem.upgradeTask.buyerTask" class="taskItem">
          <div :class="currentLevelItem.levelClass" class="iconBox">
            <span class="iconfont icon-iconfont31quanbushangpin1"></span>
          </div>
          <div class="itemRightBox">
            <div class="itemRightPart">
              <div class="subLeftPart">
                <div class="taskNameBox">
                  <span class="taskName">购买商品</span
                  ><van-tag v-if="currentLevelItem.upgradeTask.needBuyCount" type="primary" color="#feeeee" round text-color="#f26161">还差{{ currentLevelItem.upgradeTask.needBuyCount }}单</van-tag>
                  <span class="iconfont icon-icon-test" v-if="!currentLevelItem.upgradeTask.needBuyCount"></span>
                </div>
                <div class="tip" v-text="currentLevelItem.upgradeTask.buyerTask.taskCon"></div>
              </div>
              <div class="doTask normalbtn greyBtn" v-if="!currentLevelItem.upgradeTask.isAchieveCurrentLevel">请先升级至{{ currentLevelItem.upgradeTask.VLevel }}</div>
              <div v-else-if="currentLevelItem.upgradeTask.needBuyCount" class="doTask normalbtn activeBtn" @click="buyNow()">
                去购买
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 升级任务 end -->
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { Tag, Progress } from 'vant'
import { GetUpGradeInfo } from '@/api/member'
import { SaleMiniAppMyInfoGet } from '@/api/my'
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import { Indicator } from 'mint-ui'

export default {
  name: 'Home',
  components: {
    swiper,
    swiperSlide,
    'van-tag': Tag,
    'van-progress': Progress
  },
  data() {
    return {
      swiperOption: null,
      levelList: [],
      mySwiper: null,
      activeIndex: 0,
      upGradeInfo: null,
      userLevel: 1, // 会员等级
      headPortraitUrl: '', // 会员头像
      currentLevelItem: null
    }
  },
  watch: {
    'mySwiper.activeIndex': {
      deep: true,
      handler(val) {
        this.activeIndex = val
        this.currentLevelItem = this.levelList[val]
        console.log(this.activeIndex)
      }
    }
  },
  computed: {
    ...mapGetters(['getPortraitUrl']),
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    // 计算剩余时间
    surplusGetDays() {
      let currentTime = moment(this.upGradeInfo.CurrDate)
      if (currentTime.day() < 7 && currentTime.day() > 0) {
        return `剩余${7 - currentTime.day()}天可领取`
      } else {
        if (currentTime.hour() < 23) {
          return `剩余${23 - currentTime.hour()}小时可领取`
        } else {
          return `剩余${60 - currentTime.minute()}分钟可领取`
        }
      }
    }
  },
  created() {
    this.setHeader()
    this.fetchData()
  },
  mounted() {
    // this.init()
  },
  methods: {
    ...mapMutations(['SET_PORTRAIT_URL']),
    init(activeIndex) {
      this.swiperOption = {
        initialSlide: activeIndex - 1, // 设定初始化时slide的索引
        slidesPerView: 'auto', // 设置slider容器能够同时显示的slides数量(carousel模式)。
        spaceBetween: -2, // 在slide之间设置距离（单位px）。
        centeredSlides: true // 设定为true时，active slide会居中，而不是默认状态下的居左。
      }
      this.$nextTick(() => {
        this.mySwiper = this.swiper
      })
    },
    setHeader() {
      if (this.getPortraitUrl) {
        this.headPortraitUrl = this.getPortraitUrl
      } else {
        SaleMiniAppMyInfoGet().then((res) => {
          this.headPortraitUrl = res.SaleMiniAppMyInfo.HeadPortraitUrl
          this.SET_PORTRAIT_URL(this.headPortraitUrl)
        })
      }
    },
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      GetUpGradeInfo()
        .then((res) => {
          Indicator.close()
          this.upGradeInfo = res.Data
          this.setData(res.Data)
          this.init(res.Data.UserLevel)
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            Toast(err.ErrMsg)
          }
        })
    },
    setData(upGradeInfo) {
      this.levelList = [
        {
          isCurrentLevel: upGradeInfo.UserLevel === 1, // 是否是当前等级
          levelName: '白银会员', // 当前等级名称
          iconfont: 'icon-v1', // 等级图标
          levelClass: 'level1', // 等级类名
          taskProgress: this.taskProgressFilter({ cardLevel: 1 }), // 任务进度
          vipPrivilege: this.vipPrivilegeFilter({ cardLevel: 1 }), // 会员特权
          upgradeTask: this.upgradeTaskFilter({ cardLevel: 1 }) // 升级任务
        },
        {
          isCurrentLevel: upGradeInfo.UserLevel === 2,
          levelName: '黄金会员',
          iconfont: 'icon-v2',
          levelClass: 'level2',
          taskProgress: this.taskProgressFilter({ cardLevel: 2 }),
          vipPrivilege: this.vipPrivilegeFilter({ cardLevel: 2 }),
          upgradeTask: this.upgradeTaskFilter({ cardLevel: 2 }) // 升级任务
        },
        {
          isCurrentLevel: upGradeInfo.UserLevel === 3,
          levelName: '钻石会员',
          iconfont: 'icon-v3',
          levelClass: 'level3',
          taskProgress: this.taskProgressFilter({ cardLevel: 3 }),
          vipPrivilege: this.vipPrivilegeFilter({ cardLevel: 3 }),
          upgradeTask: this.upgradeTaskFilter({ cardLevel: 3 }) // 升级任务
        }
      ]
    },
    // 任务进度模块
    taskProgressFilter({ cardLevel = 1 } = null) {
      let taskProgressText = '' // 任务进度文字
      let isShowProgress = false // 是否展示进度条
      let percentage = 0 // 进度条百分比
      let progressColor = '#C0C7D4' // 进度条颜色
      let userLevel = this.upGradeInfo.UserLevel // 当前用户等级
      let needBuyCount = this.upGradeInfo.NeedBuyCount // 还需购买订单数
      let needFriendCount = this.upGradeInfo.NeedFriendCount // 还需邀请好友数
      let isShowGoToUpgrade = false // 是否展示去升级按钮
      let changeCardLevel = 0 // 点击去升级按钮切换到哪个等级的卡片
      switch (cardLevel) {
        case 1:
          // 白银会员
          if (userLevel > cardLevel) {
            // 若当前大于V1，则展现为文字：当前高于该等级
            taskProgressText = '当前高于该等级'
          } else {
            // 若当前为V1，则根据实际进度展现
            taskProgressText = `已购买${2 - needBuyCount}单、已邀请${1 - needFriendCount}位好友`
            percentage = ((needBuyCount + needFriendCount) / 3) * 100
            isShowProgress = true
            progressColor = '#C0C7D4'
          }
          break
        case 2:
          // 黄金会员
          if (userLevel > cardLevel) {
            // 若当前大于V2，则展现为文字：当前高于该等级
            taskProgressText = '当前高于该等级'
          } else if (userLevel === cardLevel) {
            taskProgressText = `已购买${10 - needBuyCount}单、已邀请${5 - needFriendCount}位好友`
            percentage = ((needBuyCount + needFriendCount) / 15) * 100
            isShowProgress = true
            progressColor = '#F7C163'
          } else {
            // 若当前等级小于V2，则展现：请升级成V2会员，享受会员权益；给出【去升级】按钮 - 点击跳转V1等级卡片
            taskProgressText = '请升级成V2会员，享受会员权益'
            isShowGoToUpgrade = true
            changeCardLevel = 0
          }
          break
        default:
          // 钻石会员
          if (userLevel < cardLevel) {
            // 若小于V3，则展现为：请升级成V3会员，享受会员权益；给出【去升级】按钮 - 点击跳转V2等级卡片
            taskProgressText = '请升级成V3会员，享受会员权益'
            isShowGoToUpgrade = true
            changeCardLevel = 1
          } else {
            // 若等于V3，则展现为：恭喜你！已达到最高等级
            taskProgressText = '恭喜你！已达到最高等级'
          }
          break
      }
      return {
        taskProgressText: taskProgressText, // 任务进度文字
        isShowProgress: isShowProgress, // 是否展示进度条
        percentage: percentage, // 进度条百分比
        progressColor: progressColor, // 进度条颜色
        isShowGoToUpgrade: isShowGoToUpgrade, // 是否展示去升级按钮
        changeCardLevel: changeCardLevel // 点击去升级按钮切换到哪个等级的卡片
      }
    },
    // 去升级
    goToUpgrade(changeCardLevel) {
      this.$refs.mySwiper.swiper.activeIndex = changeCardLevel
    },
    // 会员特权模块
    vipPrivilegeFilter({ cardLevel = 1 } = null) {
      let vipPrivilegeText = '' // 会员特权说明
      let userLevel = this.upGradeInfo.UserLevel // 当前用户等级
      let vipPrivilegeBtnStatus = 1 // 1:留空,2:未达到,3:剩余时间,4:前往领取
      let isGetWeekWelfare = this.upGradeInfo.IsGetWeekWelfare // 是否领取每周福利免单卡
      switch (cardLevel) {
        case 1:
          // 白银会员
          if (userLevel > cardLevel) {
            // 若当前大于V1，则展现为：V1会员暂不享受会员权益
            vipPrivilegeText = 'V1会员暂不享受会员权益'
          } else {
            // 若当前为V1，则展现为：V1会员暂不享受会员权益，请升级~
            vipPrivilegeText = 'V1会员暂不享受会员权益，请升级~'
          }
          break
        case 2:
          // 黄金会员
          vipPrivilegeText = '享受每周免费领取1张免单卡'
          if (userLevel > cardLevel) {
            // 若大于V2，则留空即可
            vipPrivilegeBtnStatus = 1
          } else if (userLevel === cardLevel) {
            // 若为V2，未领取本周免单卡，则展现为【前往领取】 - 点击跳转免单卡中心页面；已领取本周免单卡，则按照原有页面逻辑展现为【剩余x天可领取】
            isGetWeekWelfare ? (vipPrivilegeBtnStatus = 3) : (vipPrivilegeBtnStatus = 4)
          } else {
            // 若当前小于V2，右侧需要额外展现【未达到】字眼
            vipPrivilegeBtnStatus = 2
          }
          break
        default:
          // 钻石会员
          vipPrivilegeText = '享受每周免费领取2张免单卡'
          if (userLevel < cardLevel) {
            // 若当前小于V3，右侧需要额外展现【未达到】字眼
            vipPrivilegeBtnStatus = 2
          } else {
            // 若当前为V3，未领取本周免单卡，则展现为【前往领取】 - 点击跳转免单卡中心页面；已领取本周免单卡，则按照原有页面逻辑展现为【剩余x天可领取】
            isGetWeekWelfare ? (vipPrivilegeBtnStatus = 3) : (vipPrivilegeBtnStatus = 4)
          }
          break
      }
      return {
        vipPrivilegeText: vipPrivilegeText, // 会员特权说明
        vipPrivilegeBtnStatus: vipPrivilegeBtnStatus // 1:留空,2:未达到,3:剩余时间,4:前往领取
      }
    },
    // 前往领取
    getFreeCard() {
      this.$router.push({ name: 'collarCartCenter' })
    },
    // 升级任务模块
    upgradeTaskFilter({ cardLevel = 1 } = null) {
      let haveTask = true // 是否有任务
      let userLevel = this.upGradeInfo.UserLevel // 当前用户等级
      let needBuyCount = this.upGradeInfo.NeedBuyCount // 还需购买订单数
      let needFriendCount = this.upGradeInfo.NeedFriendCount // 还需邀请好友数
      let isAchieveCurrentLevel = true // 是否达到当前等级
      let inviteFrientTask = null // 邀请好友的任务
      let buyerTask = null // 买手的任务
      let taskProgressIcon = null // 任务进度icon
      switch (cardLevel) {
        case 1:
          // 白银会员
          inviteFrientTask = {
            icon: 'icon-yaoqing2',
            taskName: '邀请好友',
            taskCon: '邀请 1 位好友'
          }
          buyerTask = {
            icon: 'icon-yaoqing2',
            taskName: '购买商品',
            taskCon: '购买 2 单并领取返利'
          }
          if (userLevel > cardLevel) {
            needBuyCount = 0
            needFriendCount = 0
          }
          taskProgressIcon = {
            from: 'icon-v11',
            to: 'icon-v21'
          }
          break
        case 2:
          // 黄金会员
          inviteFrientTask = {
            icon: 'icon-yaoqing2',
            taskName: '邀请好友',
            taskCon: '邀请 5 位好友'
          }
          buyerTask = {
            icon: 'icon-yaoqing2',
            taskName: '购买商品',
            taskCon: '购买 10 单并领取返利'
          }
          if (userLevel > cardLevel) {
            needBuyCount = 0
            needFriendCount = 0
          } else if (userLevel < cardLevel) {
            needBuyCount = 10
            needFriendCount = 5
            isAchieveCurrentLevel = false
          }
          taskProgressIcon = {
            from: 'icon-v21',
            to: 'icon-v31'
          }
          break
        default:
          // 钻石会员
          haveTask = false
          break
      }
      return {
        haveTask: haveTask, // 是否有任务
        VLevel: 'V' + cardLevel, // 任务代号
        inviteFrientTask: inviteFrientTask, // 邀请好友的任务
        buyerTask: buyerTask, // 买手的任务
        needBuyCount: needBuyCount, // 还需购买订单数
        needFriendCount: needFriendCount, // 还需邀请好友数
        isAchieveCurrentLevel: isAchieveCurrentLevel, // 是否达到当前等级
        taskProgressIcon: taskProgressIcon // 任务进度icon
      }
    },
    // 去购买
    buyNow() {
      this.$router.push({ name: 'zeroBuyMain' })
    },
    // 去邀请
    invitationNow() {
      this.$router.push({
        name: 'ShareByImg',
        query: {
          pageType: 13
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.NewMemberUpgrade {
  overflow: scroll;
  background: #f0f0f2;
  font-size: 14px;
  min-height: 100vh;
}
.partOne {
  background-color: #fff;
}
.NewMemberUpgrade .swiper-container {
  position: relative;
  width: 100%;
  height: auto;
}
.normalbtn {
  // min-width: vw(76);
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: vw(13);
  color: rgba(136, 136, 136, 100);
  border: 1px solid rgba(187, 187, 187, 100);
  height: vw(30);
  border-radius: vw(15);
  padding: 0 vw(12);
}
.textBtn {
  min-width: vw(76);
  text-align: center;
}
.activeBtn {
  color: #3b3d45;
  border: 1px solid #3b3d45;
}
.greyBtn {
  background-color: #f0f0f2;
  border: none;
  color: #999999;
}
.NewMemberUpgrade .swiper-container .swiper-slide {
  width: vw(303);
  height: vw(163);
  color: #000;
  font-size: 16px;
  text-align: center;
  margin: vw(32) 0;
  .card {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    width: 100%;
    height: 100%;
    background-color: #dee3ed;
    border-radius: vw(5);
    padding: vw(28) vw(16) 0;
    box-sizing: border-box;
    box-shadow: -2px 11px 10px 0 hsla(0, 2%, 75%, 0.5);
    .bgModify {
      position: absolute;
      right: vw(8);
      top: vw(-4);
      font-size: vw(70);
      color: #c0c7d6;
      opacity: 0.4;
    }
    .currentLevel {
      position: absolute;
      top: 0;
      left: 0;
      font-size: vw(10);
      color: #666666;
      border: 1px solid rgba(185, 194, 213, 0.6);
      padding: 0 vw(6);
      border-top-left-radius: vw(5);
      border-bottom-right-radius: vw(5);
    }
    .topPart {
      display: flex;
      align-items: center;
      height: vw(40);
      margin-bottom: vw(42);
      .header {
        width: vw(40);
        height: vw(40);
        margin-right: vw(6);
      }
      .iconfont {
        font-size: vw(20);
        margin-right: vw(4);
      }
      .levelName {
        font-size: vw(17);
        font-weight: 700;
      }
    }
    .bottomPart {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-left: vw(4);
      .textspeedOfProgress {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #2e2e2e;
        font-size: vw(12);
        height: vw(22);
        .goToUpgrade {
          display: flex;
          align-items: center;
          justify-content: space-around;
          color: #3b3d45;
          font-size: vw(12);
          padding: 0 vw(10);
          height: vw(22);
          border: 1px solid #3b3d45;
          border-radius: vw(11);
        }
      }
      .speedOfProgress {
        width: vw(145);
        margin-top: vw(6);
      }
    }
  }
  .card.level2 {
    background-color: #fbe6b1;
    .currentLevel {
      border: 1px solid rgba(247, 199, 104, 0.6);
      color: #666666;
    }
    .bgModify {
      color: #f7c163;
    }
    .bottomPart {
      .textspeedOfProgress {
        color: #2e2e2e;
      }
    }
  }
  .card.level3 {
    background-color: #3b3d45;
    color: #fff;
    .currentLevel {
      color: #f7f7f7;
      border: 1px solid rgba(187, 187, 187, 0.6);
    }
    .bgModify {
      color: #666666;
    }
    .bottomPart {
      .textspeedOfProgress {
        color: #ffffff;
        .goToUpgrade {
          color: #ffffff;
          border: 1px solid #ffffff;
        }
      }
    }
  }
}
.swiper-slide {
  transition: 300ms;
  transform: scale(0.85);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
.vipPrivilege {
  padding: 0 vw(15) vw(19);
  box-sizing: border-box;
  .title {
    font-size: vw(17);
    font-weight: 700;
  }
  .privilegeCard {
    display: flex;
    align-items: center;
    width: 100%;
    height: vw(70);
    background-color: #f0f0f2;
    margin-top: vw(12);
    border-radius: vw(5);
    box-sizing: border-box;
    padding: 0 vw(11) 0 vw(18);
    .leftPart {
      flex: 1;
      display: flex;
      align-items: center;
      .iconfont {
        font-size: vw(23);
        margin-right: vw(13);
      }
      .subCon {
        .subTitle {
          font-size: vw(15);
          color: rgba(53, 53, 53, 100);
        }
        .subTip {
          font-size: vw(13);
          color: rgba(136, 136, 136, 100);
        }
      }
    }
    .btnStatus1 {
      padding: 0 vw(8);
    }
    .btnStatus2 {
      font-size: vw(15);
      color: rgba(46, 46, 46, 100);
    }
    .btnStatus3 {
    }
  }
}
.upgradeTask {
  padding: 0 vw(15);
  box-sizing: border-box;
  background-color: #fff;
  margin-top: vw(11);
  .title {
    display: flex;
    align-items: center;
    font-size: vw(17);
    font-weight: 700;
    padding: vw(12) 0;
    border-bottom: 1px solid #f0f0f2;
    .stage {
      margin-left: vw(4);
      color: #3b3d45;
    }
  }
  .taskList {
    .taskItem {
      display: flex;
      align-items: center;
      height: vw(90);
      .iconBox {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: vw(45);
        height: vw(45);
        border-radius: 50%;
        background-color: rgba(251, 230, 177, 0.55);
        margin-right: vw(12);
        .iconfont {
          font-size: vw(24);
          color: #f7c163;
        }
        &.level1 {
          background: rgba(222, 227, 237, 0.55);
          .iconfont {
            color: #999999;
          }
        }
      }
      .itemRightBox {
        display: flex;
        align-items: center;
        flex: 1;
        height: 100%;
        border-bottom: 1px solid #f0f0f2;
        .itemRightPart {
          flex: 1;
          height: vw(45);
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-right: vw(11);
          .subLeftPart {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .taskNameBox {
              display: flex;
              align-items: center;
              .taskName {
                font-size: vw(15);
                // font-weight: 700;
                margin-right: vw(6);
              }
              .icon-icon-test {
                color: #7ac756;
                font-size: vw(14);
              }
            }
            .tip {
              color: #999999;
              font-size: vw(13);
            }
          }
          .doTask {
          }
        }
      }
    }
  }
}
</style>
